// extracted by mini-css-extract-plugin
export default {"registerModal":"authentication_registerModal__OmSfQ","loginModal":"authentication_loginModal__ClYF-"};